import { useEffect } from 'react';
import { registerImageCacheServiceWorker } from '$/utils/registerImageCacheServiceWorker';

/** 应用根级注册 Team Flow 图片缓存 Service Worker，不渲染可见内容。 */
function ImageCacheServiceWorkerRegistrar() {
  useEffect(() => {
    registerImageCacheServiceWorker();
  }, []);

  return null;
}

export default ImageCacheServiceWorkerRegistrar;
